import React from 'react';
import { Flex, IconButton } from '@chakra-ui/react';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import PropTypes from 'prop-types';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

export default function PrevNextBtn({
  contentKey,
  onScrollLeft,
  onScrollRight,
  ...props
}) {
  const { tt } = useUiComponentsInternationalContext();

  return (
    <Flex
      gap={2}
      transform="translateY(-65%)"
      zIndex={1}
      position="absolute"
      {...props}
    >
      <IconButton
        aria-label={tt(s => s.prevNextBtnComponent.previousAriaLabel)}
        minWidth={8}
        height={8}
        icon={<MdKeyboardArrowLeft size={24} />}
        onClick={() => {
          onScrollLeft(contentKey);
        }}
        variant="primary"
      />
      <IconButton
        aria-label={tt(s => s.prevNextBtnComponent.nextAriaLabel)}
        minWidth={8}
        height={8}
        icon={<MdKeyboardArrowRight size={24} />}
        onClick={() => {
          onScrollRight(contentKey);
        }}
        variant="primary"
      />
    </Flex>
  );
}

PrevNextBtn.propTypes = {
  contentKey: PropTypes.string.isRequired,
  onScrollLeft: PropTypes.func.isRequired,
  onScrollRight: PropTypes.func.isRequired,
};
